import React, { useState, useEffect } from "react";
import styles from "./ProductListing.module.css";
import { Link, useParams } from "react-router-dom";
import axiosPrivate from "../../../hooks/axiosPrivate";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { useContext } from "react";
import LoaderContext from "../../../context/Loader/LoaderContext";
import amazonImg from "../../../assets/images/amazon_new.webp";
import flipkartImg from "../../../assets/images/flipkart.png";
import amazonMobileImg from "../../../assets/images/AmazonMobilePNG.png";
import flipkartMobileImg from "../../../assets/images/flipkartMobile.png";
import StarRating from "../StarRating/StarRating";
import PageTitleWithLeaf from "../../PageTitleWithLeaf";
import CustomButton from "../../custom-button";
import { classNames } from "primereact/utils";
import { removeFont16pxFromStyle } from "../../../utils/utils.function";
function ProductDinamicPage({ initialValues }) {
  const { setLoaderCheck } = useContext(LoaderContext);
  const [isUrbanGarden, setIsUrbanGarden] = useState(window);

  function productslug(slug) {
    return slug
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, "")
      .replace(/[\s_-]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }


  return (
    <div>
      {window.location.pathname?.includes("urban-gardens") ? (
        <div
          className={classNames(
            styles.urbanNewMainContainer,
            "section-spacing-top"
          )}
        >
          <PageTitleWithLeaf text={"Urban Gardens"} />

          <div className={styles.urbanFirstSection}>
            <img
              src={initialValues?.mainImage}
              alt={initialValues?.mainImageAlt}
              loading="lazy"
              className={styles.urbanBannerImage}
            />
            <div className={styles.overlapContainer}></div>
            <div className={styles.urbanBannerContents}>
              <h2 className={styles.urbanBannerHeading1}>Organic Solutions</h2>
              <h2 className={styles.urbanBannerHeading1}>
                for Effortless Urban Gardening
              </h2>
            </div>
          </div>
          <div>
            <div style={{ position: "relative" }}>
              <img
                src="/assets/images/home/ellipse.png"
                alt="ellipse"
                loading="lazy"
                className={styles.secondSectionEllipse}
              />
            </div>

            <div className={`${styles.secondSectionCards} container`}>
              <div className={styles.whyChooseSection}>
                <div className={styles.whyChooseSubSection}>
                  <h4 className={styles.whyChooseSubSectionLeftContent}>
                    Why Choose Minfert?
                  </h4>
                  <div className={styles.whyChooseSubSectionRightContent}>
                    <div className={styles.rightLogoContentAlign}>
                      <img
                        src="/assets/images/home/OrganicLogo.png"
                        alt="ellipse"
                        loading="lazy"
                        className={styles.logoImg}
                      />
                      <div className={styles.logoSectionContent}>
                        100% Certified
                        <br />
                        Organic Product
                      </div>
                    </div>
                    <div className={styles.rightLogoContentAlign}>
                      <img
                        src="/assets/images/home/LowerCostLogo.png"
                        alt="ellipse"
                        loading="lazy"
                        className={styles.logoImg}
                      />
                      <div className={styles.logoSectionContent}>
                        Get More Produce
                        <br />
                        at Lower Cost
                      </div>
                    </div>
                    <div className={styles.rightLogoContentAlign}>
                      <img
                        src="/assets/images/home/SoilSofterLogo.png"
                        alt="ellipse"
                        loading="lazy"
                        className={styles.logoImg}
                      />
                      <div className={styles.logoSectionContent}>
                        Making Soil
                        <br />
                        Softer
                      </div>
                    </div>
                    <div className={styles.rightLogoContentAlign}>
                      <img
                        src="/assets/images/home/LabTestedLogo.png"
                        alt="ellipse"
                        loading="lazy"
                        className={styles.logoImg}
                      />
                      <div className={styles.logoSectionContent}>
                        Lab Tested and
                        <br />
                        Certified
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={classNames(styles.secondSectionDescription, "mt-2")}
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: removeFont16pxFromStyle(
                      initialValues?.categorySection[0]?.content
                    ),
                  }}
                ></div>
              </div>
            </div>
          </div>
          <div
            className={classNames(
              styles.exclusiveProductsSection,
              "section-p-spacing-top"
            )}
          >
            <h6 className={classNames(styles.exclusiveProductHeading, "mb-3")}>
              Exclusive Products
            </h6>
            <div className={`container ${styles.exclusiveProductsWrapper}`}>
              {initialValues?.ProductSection.map((product, index) => (
                <div className={styles.exclusiveProductCard}>
                  <img
                    src={product?.productImage}
                    alt={product?.productImageAlt}
                    loading="lazy"
                    className={styles.exclusiveProductImage}
                  />
                  <div className={styles.productDetailsMainContent}>
                    <div className={styles.productDetailSubContent}>
                      <div className={styles.productDetailsContent}>
                        <h4 className={styles.productName}>{product?.name}</h4>
                        <div className="pt-1">
                          <StarRating size={20} value={product?.rating_star} />
                        </div>
                      </div>
                      <div className={styles.productCategory}>
                        {product?.category_name}
                      </div>
                    </div>
                    <div className={styles.buttonsContainer}>
                      {/* <a
                        href={product?.product_pdf}
                        className={styles.cardInactiveButton}
                        target="_blank"
                      >
                        Know More
                      </a> */}
                      <Link
                        to={`/product-detail/` + productslug(product.slug)}
                        className={styles.cardActiveButton}
                      >
                        Shop Now
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <div className="container section-spacing-top section-spacing-bottom">
          <div>
            <PageTitleWithLeaf
              text={initialValues?.categorySection[0]?.heading}
            />
            <div className={`${styles.imgDiv} section-spacing-bottom`}>
              <img
                className={styles.categoryImg}
                src={initialValues?.mainImage}
                alt={initialValues?.mainImageAlt}
              />

              <div
                className={styles.categoryContent}
                dangerouslySetInnerHTML={{
                  __html: removeFont16pxFromStyle(
                    initialValues?.categorySection[0]?.content
                  ),
                }}
              />
            </div>
          </div>
          <div className={styles.productListContainer}>
            {initialValues?.ProductSection.length > 0 ? (
              <>
                {initialValues?.ProductSection.map((product, index) => (
                  <>
                    <div className={styles.productList}>
                      <div className={styles.productImg}>
                        <Link
                          to={`/product-detail/` + productslug(product?.slug)}
                        >
                          <img
                            src={product?.productImage}
                            alt={product?.productImageAlt}
                            loading="lazy"
                          />
                        </Link>
                      </div>
                      <div className={`${styles.productDetail}`}>
                        <Link
                          to={`/product-detail/` + productslug(product.slug)}
                        >
                          <h2 className={styles.productName}>{product.name}</h2>
                        </Link>
                        <Link to={`/${product.category_slug}`}>
                          <h4 style={{ fontSize: "1.1rem" }}>
                            {product?.category_name}
                          </h4>
                        </Link>
                        <p>{product.forms}</p>
                        <div
                          style={{ marginTop: "20px", fontSize: "14px" }}
                          dangerouslySetInnerHTML={{
                            __html: removeFont16pxFromStyle(
                              product?.short_description
                            ),
                          }}
                        />
                        <div className={`${styles.desktopLinks}`}>
                          <div className={`${styles.desktopBtn}`}>
                            <Link
                              to={
                                `/product-detail/` + productslug(product.slug)
                              }
                            >
                              <CustomButton text={"Shop Now"} style={{}} />
                            </Link>
                            <a href={product?.product_pdf}>
                              <CustomButton text={"Know More"} style={{}} />
                            </a>
                          </div>
                          <div className={`${styles.desktopBtn}`}>
                            {product?.amazon_link !== null &&
                              product?.amazon_link !== "" &&
                              product?.amazon_link !== "null" && (
                                <Link
                                  className={`${styles.desktopLogo}`}
                                  to={product?.amazon_link}
                                >
                                  <img
                                    className={`${styles.desktopLogoImage1}`}
                                    src={amazonImg}
                                    alt="amazon logo"
                                  />
                                </Link>
                              )}

                            {product?.flipkart_link !== null &&
                              product?.flipkart_link !== "" &&
                              product?.flipkart_link !== "null" && (
                                <Link
                                  to={product?.flipkart_link}
                                  className={`${styles.desktopLogo}`}
                                >
                                  <img
                                    className={`${styles.desktopLogoImage2}`}
                                    src={flipkartImg}
                                    alt="flipkart logo"
                                    srcset=""
                                  />
                                </Link>
                              )}
                          </div>
                        </div>
                      </div>
                      <div className={styles.mobileBtn}>
                        <Link
                          to={`/product-detail/` + productslug(product.slug)}
                        >
                          <CustomButton text={"Shop Now"} style={{}} />
                        </Link>
                        <a href={product?.product_pdf} target="_blank">
                          <CustomButton text={"Know More"} style={{}} />
                        </a>
                        {product?.amazon_link !== null &&
                          product?.amazon_link !== "" &&
                          product?.amazon_link !== "null" && (
                            <Link
                              to={product?.amazon_link}
                              className={`${styles.desktopLogo}`}
                            >
                              <img
                                className={`${styles.desktopLogoImage1}`}
                                src={amazonMobileImg}
                                alt="amazonMobileImg"
                                srcset=""
                              />
                            </Link>
                          )}
                        {product?.flipkart_link !== null &&
                          product?.flipkart_link !== "" &&
                          product?.flipkart_link !== "null" && (
                            <Link
                              to={product?.flipkart_link}
                              className={`${styles.desktopLogo}`}
                            >
                              <img
                                className={`${styles.desktopLogoImage1}`}
                                src={amazonMobileImg}
                                alt="amazonMobileImg"
                                srcset=""
                              />
                            </Link>
                          )}
                      </div>
                    </div>
                  </>
                ))}
              </>
            ) : (
              "NO Product found"
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default React.memo(ProductDinamicPage); // Memoize the ProductDinamicPage;
